// Mock data for GiCleanly

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Blog', href: '#blog' },
  { label: 'Contact', href: '#contact' },
];

export const heroSlides = [
  {
    id: 1,
    tag: 'PROFESSIONAL SERVICE',
    title: 'Sparkling Homes,',
    titleHighlight: 'Every Time.',
    subtitle: 'A cleaning service you can truly rely on — from top to bottom, we handle it all.',
    cta: 'Get a Free Estimate',
    image: 'https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb',
  },
  {
    id: 2,
    tag: 'ECO-FRIENDLY',
    title: 'Green Cleaning,',
    titleHighlight: 'Healthy Living.',
    subtitle: 'We use eco-friendly products that are safe for your family, pets and the planet.',
    cta: 'Book Your Clean',
    image: 'https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce',
  },
  {
    id: 3,
    tag: 'NEW CLIENT OFFER',
    title: '10% OFF',
    titleHighlight: 'Your First Clean.',
    subtitle: 'Applied to your first invoice with a contract. Mention code “NEW25” to redeem.',
    cta: 'Claim Discount',
    image: 'https://images.unsplash.com/photo-1781637590564-01c65dbf2039',
  },
];

export const services = [
  {
    id: 'residential',
    kicker: 'Residential',
    title: 'Cleaning',
    image: 'https://images.unsplash.com/photo-1649083048770-82e8ffd80431',
    description: 'When you work with GiCleanly you can cross a major chore off your list — cleaning your home.',
    subtitle: 'One Time Residential Cleaning / Recurring',
    itemsLeft: ['Kitchen', 'Bathrooms', 'Bedrooms & Living Rooms', 'Windows', 'Extra Services'],
    itemsRight: ['Carpet', 'Seasonal', 'Move in/out', 'Post construction', 'Express'],
    cta: 'Get a Free Estimate',
  },
  {
    id: 'commercial',
    kicker: 'Commercial',
    title: 'Cleaning',
    image: 'https://images.pexels.com/photos/10567361/pexels-photo-10567361.jpeg',
    description: 'At GiCleanly we use a wide variety of cleaning methods, chemicals, and equipment to facilitate and expedite the cleaning process.',
    subtitle: 'One Time Commercial Cleaning / Recurring',
    itemsLeft: ['Office', 'Shops', 'Medical facilities', 'Factories', 'Restaurants'],
    itemsRight: ['Warehouses', 'Airports', 'Move in/out', 'Government facilities', 'Showrooms'],
    cta: 'Get a Free Estimate',
  },
];

export const reasons = [
  {
    id: 1,
    stat: 'Monthly',
    label: '500 cleans',
    description: 'Our microfiber cloths, which capture dust and dirt rather than move it around, last longer than traditional cotton.',
    icon: 'Sparkles',
  },
  {
    id: 2,
    stat: '100%',
    label: 'Satisfaction',
    description: 'A money-back guarantee. If you are not satisfied, let us know within 48 hours after the service has been carried out.',
    icon: 'BadgeCheck',
  },
  {
    id: 3,
    stat: 'Eco-Friendly',
    label: 'Cleaning Products',
    description: 'Because indoor pollution rates are typically higher than outdoor pollution, we take dust removal seriously.',
    icon: 'Leaf',
  },
  {
    id: 4,
    stat: 'Cost',
    label: 'Effective',
    description: 'Precision cleaning is required throughout a broad range of modern industries and homes at prices that make sense.',
    icon: 'PiggyBank',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Eimear McGeown',
    rating: 5,
    text: 'Best cleaner we\u2019ve found in London.',
    source: 'Google',
  },
  {
    id: 2,
    name: 'Jennifer de la Fuente',
    rating: 5,
    text: 'Lloyd and Rafaela came over and whipped this flat into shape! They went above and beyond, doing all windows and little things I hadn\u2019t thought of, like the cabinets. I\u2019m impressed by their quality of work and will definitely use this company again for a deep clean. I highly recommend!',
    source: 'Google',
  },
  {
    id: 3,
    name: 'Aparna Dileep',
    rating: 5,
    text: 'We booked GiCleanly for a one off cleaning service and were very happy with the results. The cleaner Ana was very professional and courteous and left the place spotless. The booking and communication was seamless.',
    source: 'Google',
  },
  {
    id: 4,
    name: 'Toni M',
    rating: 5,
    text: 'I highly recommend GiCleanly for your cleaning service needs. Not only did they provide professional and reliable cleaning services, but Karina who attended was absolutely brilliant. Give them a try, and you\u2019ll be delighted with their service!',
    source: 'Google',
  },
  {
    id: 5,
    name: 'Rafa Macedo',
    rating: 5,
    text: 'I recently hired this service for an end-of-tenancy deep clean and I\u2019m beyond impressed. From start to finish, they went above and beyond, leaving the property spotless. Highly recommend!',
    source: 'Google',
  },
  {
    id: 6,
    name: '1iiev1y',
    rating: 5,
    text: 'The cleaners have done very well, and the service of the whole process is also very responsible.',
    source: 'Google',
  },
];

export const steps = [
  {
    id: 1,
    title: 'Easy Online Scheduling',
    subtitle: 'Just a Few Clicks',
    icon: 'CalendarCheck',
  },
  {
    id: 2,
    title: 'Cleaning with Care',
    subtitle: 'and Eco-Friendly Products',
    icon: 'SprayCan',
  },
  {
    id: 3,
    title: 'Enjoy Cleanliness',
    subtitle: 'and Shine Around You',
    icon: 'Home',
  },
];

export const contactInfo = {
  phone: '07547 340708',
  email: 'gicleanly@gmail.com',
  address: 'The Avenue 44, Wembley, HA9 9PN, United Kingdom',
  hours: 'Mon – Sat: 8:00 – 20:00',
};
